import React from 'react';
import TextEntities from 'lib/TextEntities';
import TextWithEntities from 'components/TextWithEntities.jsx';


const NameAndSignatureQuery = ({ displayName, fullName, query }) => {
  const parser = TextEntities.createTextMatchingParser(query);
  if (query !== '' && fullName && parser(fullName).length > parser(displayName).length) {
    fullName = <TextWithEntities text={`(${fullName})`} entities={parser(`(${fullName})`)} />;
  } else {
    fullName = '';
  }
  displayName = <TextWithEntities text={displayName} entities={parser(displayName)} />;

  return (
    <div>
      {displayName}
      {' '}
      {fullName}
    </div>
  );
};

NameAndSignatureQuery.propTypes = {
  displayName: React.PropTypes.string,
  fullName: React.PropTypes.string,
  query: React.PropTypes.string,
};

export default NameAndSignatureQuery;



// WEBPACK FOOTER //
// ./src/components/NameAndSignatureQuery.jsx